import 'mdn-polyfills/NodeList.prototype.forEach';
import vhCheck from 'vh-check';

export default class Header {
  constructor(element) {
    this.element = element;
    this.height = this.element.offsetHeight;
    this.hasResized = true;
    this.tmpWidth = 0;
    this.hasScrolled = true;
    this.tmpScroll = document.documentElement.scrollTop;
    this.lastDcrollDown = document.documentElement.scrollTop;
    this.direction = 'down';
    this.isPinned = false;
    this.isSticky = false;

    this.handleScroll = this.handleScroll.bind(this);
    this.handlePinned = this.handlePinned.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }



  handlePinned() {
    this.element.removeEventListener('transitionend', this.handlePinned);
    this.element.classList.remove('is-pinned');
    this.element.classList.remove('is-leaving');
    this.isPinned = false;
  }

  handleScroll() {
    this.hasScrolled = true;
  }

  handleResize() {
    this.hasResized = true;
  }

  calculate() {
    const vh = vhCheck();
    this.height = this.element.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${this.height}px`);
    document.documentElement.style.setProperty('--vh-offset', `${vh.offset}px`);

    const scrollbarWidth = window.innerWidth - document.body.clientWidth
    document.body.style.setProperty("--scrollbarWidth", `${scrollbarWidth}px`)
  }

  updateResize() {
    if (this.tmpWidth !== this.element.offsetWidth) {
      this.height = this.element.offsetHeight;

      this.tmpWidth = this.element.offsetWidth;
      this.calculate();
    }
  }

  updateScroll() {
      if(document.documentElement.scrollTop > this.tmpScroll) {
        this.lastDcrollDown = document.documentElement.scrollTop;
        this.direction = 'down';
      } else {
        this.direction = 'up';
      }

      if (document.documentElement.scrollTop > this.height) {
        this.element.classList.add('is-sticky');
        this.isSticky = true;
        this.calculate();
      } else {
        this.element.classList.remove('is-sticky');
        this.element.classList.remove('is-pinned');
        this.isSticky = false;
        this.isPinned = false;
        this.calculate();
      }

      if(this.isSticky) {
        if (this.direction === 'up') {
          const delta = this.lastDcrollDown - document.documentElement.scrollTop;
          if(delta > 150) {
            this.element.classList.add('is-pinned');
            this.isPinned = true;
          }
        } else {
          if(this.isPinned) {
            this.element.addEventListener('transitionend', this.handlePinned);
            this.element.classList.add('is-leaving');
          }
        }

      this.tmpScroll = document.documentElement.scrollTop;
    }
  }

  mount() {
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll);

      const loop = () => {
        if (this.hasScrolled) {
          this.updateScroll();
          this.hasScrolled = false;
        }
        if (this.hasResized) {
          this.updateResize();
          this.hasResized = false;
        }

        requestAnimationFrame(loop);
      }

      loop();

      this.element.classList.add('is-mounted');
      this.calculate();


  }

  unmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);

    this.element.classList.remove('is-mounted');
  }
}
